import React, { ReactNode } from 'react';

import { twMerge } from 'tailwind-merge';

import { useAnalytics } from '../../../../contexts/AnalyticsContext/AnalyticsContext';
import { trackEvent } from '../../../../helpers/analytics/trackEvent';
import { EventMykissShareClicked } from '../../../../interfaces/events';
import { LikeButton, LikeType } from '../../../LikeButton/LikeButton';
import { ShareButton } from '../../../ShareButton/ShareButton';

interface PostActionsProps {
  children: ReactNode | ReactNode[];
  className?: string;
  isPostLiked: boolean;
  onLikesInfoViewChange: () => void;
  onNotLoggedIn?: () => void;
  postId: string;
  postLikesCount: number;
  postType: LikeType;
  postURL: string;
}

export const PostActions = ({
  children,
  className,
  isPostLiked,
  onLikesInfoViewChange: handleLikesInfoClick,
  onNotLoggedIn: handleNotLoggedIn,
  postId,
  postLikesCount,
  postType,
  postURL,
}: PostActionsProps) => {
  const childrenArray = Array.isArray(children) ? children : [children];
  const [detailsLink, moreCommentsLink] = childrenArray;
  const { currentPage } = useAnalytics();
  const parentComponent = postType;

  const handleLikesButtonClick = (): void => {
    void trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        type: 'read-more',
        source: 'post-viewer-like',
        page: currentPage,
      },
    });
  };

  const handleShareButtonClick = (
    destination: EventMykissShareClicked['properties']['destination'],
  ): void => {
    void trackEvent({
      name: 'mykiss_share_clicked',
      properties: { page: currentPage, destination, source: 'post-viewer-share' },
    });
  };

  return (
    <footer className={twMerge('p-4', className)}>
      <section className="flex items-start justify-between gap-y-3">
        <div className="relative flex items-start">
          <LikeButton
            className="text-abyss!"
            isLiked={isPostLiked}
            key={postId}
            labelPosition="bottom"
            likesInfoClassName="mt-3"
            numberOfLikes={postLikesCount}
            onLikesButtonClick={handleLikesButtonClick}
            onLikesInfoClick={handleLikesInfoClick}
            onNotLoggedIn={handleNotLoggedIn}
            postId={postId}
            source="post-viewer"
            type={postType}
          />
          <ShareButton
            className="text-abyss absolute left-12"
            parentComponent={parentComponent}
            onClick={() => {
              handleShareButtonClick('share-link');
            }}
            shareData={{ url: postURL }}
          ></ShareButton>
        </div>
        {detailsLink}
      </section>
      {moreCommentsLink && <section>{moreCommentsLink}</section>}
    </footer>
  );
};
